import blog1 from '../../../Assets/Cards/1Blog.png';
import blog2 from '../../../Assets/Cards/2Blog.png';
import blog3 from '../../../Assets/Cards/3Blog.png';
import blog4 from '../../../Assets/Cards/4Blog.png';
import blog5 from '../../../Assets/Cards/5Blog.png';

import card1 from '../../../Assets/Cards/blogcard1.png';
import card2 from '../../../Assets/Cards/blogcard2.png';
import card3 from '../../../Assets/Cards/blogcard3.png';
import card4 from '../../../Assets/Cards/blogcard4.png';

import card5 from '../../../Assets/Cards/blogcard5.png';
import card6 from '../../../Assets/Cards/blogcard6.png';
import card7 from '../../../Assets/Cards/blogcard7.png';
import card8 from '../../../Assets/Cards/blogcard8.png';
import card9 from '../../../Assets/Cards/blogcard9.png';
import card10 from '../../../Assets/Cards/blogcard10.png';
import card11 from '../../../Assets/Cards/blogcard11.png';
import card12 from '../../../Assets/Cards/blogcard12.png';

export const cards2=[
    {
        image:card5,
        sub:"design",
        title:"Equal blame belongs to those who fail in their duty",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"eli woolery"
    },
    {
        image:card6,
        sub:"design",
        title:"Which is the same as saying through shrinking from toil and pain",
        desc:"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled…",
        by:"jolly nilam"
    },
    {
        image:card7,
        sub:"design",
        title:"These cases are perfectly simple and easy to distinguish",
        desc:"Pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound…",
        by:"eli woolery"
    },
    {
        image:card8,
        sub:"design",
        title:"In a free hour, when our power of choice is untrammelled",
        desc:"Equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying…",
        by:"poertry jam"
    },
    {
        image:card9,
        sub:"design",
        title:"Prevents our being able to do what we like best",
        desc:"Through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour…",
        by:"laravel poet"
    },
    {
        image:card10,
        sub:"collaboration",
        title:"But in certain circumstances and owing to the claims of duty",
        desc:"When our power of choice is untrammelled and when nothing prevents our being able to do what …",
        by:"jolly nilam"
    },
    {
        image:card11,
        sub:"design",
        title:"My secret weapon for helping to the executives understand",
        desc:"Is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations…",
        by:"eli woolery"
    },
    {
        image:card12,
        sub:"design",
        title:"The wise man therefore always holds in these matters",
        desc:"Business it will frequently occur that pleasure have to be repudiated and annoyances accepted…",
        by:"poertry jam"
    }
]

export const cards1=[
    {
        image:card1,
        sub:"design",
        title:"Productivity hacks & tools for big startups in 2019",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"laravel poet"
    },
    {
        image:card2,
        sub:"collaboration",
        title:"The 4 ingredients John Maeda says all the best",
        desc:"According to Brian, this org structure provides the easiest route to a clear company mission that all can align to.",
        by:"jolly nilam"
    },
    {
        image:card3,
        sub:"design",
        title:"My secret weapon for helping to the executives understand",
        desc:"For example, as the pandemic reshaped that travel over the last nine months, this organizationa",
        by:"eli woolery"
    },
    {
        image:card4,
        sub:"design",
        title:"These 5 tips will help you nail your next design presentation",
        desc:"Technique allowed Airbnb to remain flexible and attuned to its customer needs It helped them understand",
        by:"poertry jam"
    }
]


export const blogs1Data = [
    {
       image:blog1,
       sub:"collaboration",
       title:"How Atlassian’s designers.",
       by:"natalie coy"
    },
    {
        image:blog2,
        sub:"design",
        title:"How servant leadership can help unlock.",
        by:"eli woolery"
     },
     {
        image:blog3,
        sub:"design systems",
        title:"The current advisor, d.fellow, and media designer.",
        by:"nick hahn"
     },
     {
        image:blog4,
        sub:"collaboration",
        title:"As a guiding principle in work and life, the previous.",
        by:"natalie coy"
     },
     {
        image:blog5,
        sub:"design",
        title:"t’s a value stemming from growing up in the city.",
        by:"eli woolery"
     }
]
export const cardsAuthor=[
    {
        image:card5,
        sub:"design",
        title:"Equal blame belongs to those who fail in their duty",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"liz steelman"
    },
    {
        image:card6,
        sub:"design",
        title:"Which is the same as saying through shrinking from toil and pain",
        desc:"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled…",
        by:"liz steelman"
    },
    {
        image:card7,
        sub:"design",
        title:"These cases are perfectly simple and easy to distinguish",
        desc:"Pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound…",
        by:"liz steelman"
    },
    {
        image:card8,
        sub:"design",
        title:"In a free hour, when our power of choice is untrammelled",
        desc:"Equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying…",
        by:"liz steelman"
    },
    {
        image:card9,
        sub:"design",
        title:"Prevents our being able to do what we like best",
        desc:"Through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour…",
        by:"liz steelman"
    },
    {
        image:card10,
        sub:"collaboration",
        title:"But in certain circumstances and owing to the claims of duty",
        desc:"When our power of choice is untrammelled and when nothing prevents our being able to do what …",
        by:"liz steelman"
    },
    {
        image:card11,
        sub:"design",
        title:"My secret weapon for helping to the executives understand",
        desc:"Is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations…",
        by:"liz steelman"
    },
    {
        image:card12,
        sub:"design",
        title:"The wise man therefore always holds in these matters",
        desc:"Business it will frequently occur that pleasure have to be repudiated and annoyances accepted…",
        by:"liz steelman"
    },
    {
        image:card1,
        sub:"design",
        title:"Productivity hacks & tools for big startups in 2019",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"liz steelman"
    },
    {
        image:card2,
        sub:"collaboration",
        title:"The 4 ingredients John Maeda says all the best",
        desc:"According to Brian, this org structure provides the easiest route to a clear company mission that all can align to.",
        by:"liz steelman"
    },
    {
        image:card3,
        sub:"design",
        title:"My secret weapon for helping to the executives understand",
        desc:"For example, as the pandemic reshaped that travel over the last nine months, this organizationa",
        by:"liz steelman"
    },
    {
        image:card4,
        sub:"design",
        title:"These 5 tips will help you nail your next design presentation",
        desc:"Technique allowed Airbnb to remain flexible and attuned to its customer needs It helped them understand",
        by:"liz steelman"
    },
    {
        image:card5,
        sub:"design",
        title:"Equal blame belongs to those who fail in their duty",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"liz steelman"
    },
    {
        image:card6,
        sub:"design",
        title:"Which is the same as saying through shrinking from toil and pain",
        desc:"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled…",
        by:"liz steelman"
    },
    {
        image:card7,
        sub:"design",
        title:"These cases are perfectly simple and easy to distinguish",
        desc:"Pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound…",
        by:"liz steelman"
    },
    {
        image:card8,
        sub:"design",
        title:"In a free hour, when our power of choice is untrammelled",
        desc:"Equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying…",
        by:"liz steelman"
    },
    {
        image:card9,
        sub:"design",
        title:"Prevents our being able to do what we like best",
        desc:"Through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour…",
        by:"liz steelman"
    },
    {
        image:card10,
        sub:"collaboration",
        title:"But in certain circumstances and owing to the claims of duty",
        desc:"When our power of choice is untrammelled and when nothing prevents our being able to do what …",
        by:"liz steelman"
    },
    {
        image:card1,
        sub:"design",
        title:"Productivity hacks & tools for big startups in 2019",
        desc:"Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…",
        by:"liz steelman"
    },
    {
        image:card2,
        sub:"collaboration",
        title:"The 4 ingredients John Maeda says all the best",
        desc:"According to Brian, this org structure provides the easiest route to a clear company mission that all can align to.",
        by:"liz steelman"
    },
    {
        image:card3,
        sub:"design",
        title:"My secret weapon for helping to the executives understand",
        desc:"For example, as the pandemic reshaped that travel over the last nine months, this organizationa",
        by:"liz steelman"
    },
    {
        image:card4,
        sub:"design",
        title:"These 5 tips will help you nail your next design presentation",
        desc:"Technique allowed Airbnb to remain flexible and attuned to its customer needs It helped them understand",
        by:"liz steelman"
    },
]
